import { api } from '@services';

const deleteUpdate = async (id: string): Promise<void> => {
  await api.delete<void>(`/updates/${id}`);
};

export { deleteUpdate };
